import Main from './Main';
import Chess from './Chess';

export default {
  Main,
  Chess
};



// WEBPACK FOOTER //
// ./src/components/Building/index.js